<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex flex-wrap align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user-plus" style="font-size: 22px;"></i>
            </div>
            <div class="flex-grow-1">
              <h4 class="mb-0 font-weight-bold">Add Enrollee</h4>
              <small style="opacity: .8;">Register a new enrollee for your organisation</small>
            </div>
            <router-link to="/view-clients-tpa" class="btn btn-outline-light btn-sm font-weight-bold">
              <i class="fe fe-users mr-1"></i> My enrollees
            </router-link>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <AddClientForm />
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import AddClientForm from "@/views/clients/AddClientForm.vue";

// AddClientForm loads its own lists (programmes, HMOs, facilities, LGAs) and submits the enrollee itself.
export default {
  components: {
    Navbar,
    AddClientForm,
  },
};
</script>
